'use client';

import { useRouter } from 'next/navigation';

export default function MissingPage() {
  const router = useRouter();

  return (
    <main className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
      <div className="bg-white p-8 rounded-2xl shadow-md text-center max-w-md w-full">
        <h1 className="text-3xl font-bold text-red-600 mb-4">Missing Parameters</h1>
        <p className="text-gray-700 mb-6">
          Required parameters <strong>shop</strong> or <strong>host</strong> are missing in the URL.
        </p>
        <button
          onClick={() => router.push('/')}
          className="inline-block px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
        >
          Go to Homepage
        </button>
      </div>
    </main>
  );
}
